import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-toggle",
  templateUrl: "./toggle.component.html",
  styleUrls: ["./toggle.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true,
    },
  ],
})
export class ToggleComponent
  implements OnInit, OnDestroy, ControlValueAccessor {
  private endSub$ = new Subject<void>();

  @Input() title: string = '';
  @Input() label: string = '';
  @Input() labelTranslationKey: string = '';
  @Input() labelTranslationModuleEnum: number;
  @Input() id: string = '';
  @Input() isRounded: boolean = true;
  @Input() isDisabled: boolean = false;
  @Input() isSubmitted: boolean = false;
  @Input() showValidations: boolean = true;
  @Input() loading: boolean = false;
  @Input() isRow: boolean = false;
  @Output() onChange: EventEmitter<boolean> = new EventEmitter();

  public value: boolean = false;
  public lang: string;

  // ControlValueAccessor callbacks
  private onTouched: () => void = () => {};
  private onChangeCallback: (value: boolean) => void = () => {};

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.lang = this.translate.currentLang;
    this.handleLanguageChange();
  }

  writeValue(value: boolean): void {
    this.value = value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  sendValue(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.value = checked;
    this.onChangeCallback(checked);
    this.onChange.emit(checked);
  }

  handleLanguageChange(): void {``
    this.translate.onLangChange.pipe(takeUntil(this.endSub$)).subscribe((lang) => {
      this.lang = lang.lang;
    });
  }

  toggleValue(): void {
    if (!this.isDisabled && !this.loading) {
      this.value = !this.value;
      this.onChangeCallback(this.value);
      this.onChange.emit(this.value);
    }
  }

  get isRequired(): boolean {
    return Validators.required as any;
  }


  ngOnDestroy(): void {
    this.endSub$.next();
    this.endSub$.complete();
  }
}
